import * as React from "react";
const SvgSend = props => <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 22 22" {...props}><path stroke="currentColor" strokeLinejoin="round" strokeWidth={1.8} d="m3 11 16-7-7 16-2-7z" /></svg>;
export default SvgSend;